export default __webpack_public_path__ + "static/media/party.99352e8b.png";